import '@/styles'
import './portal/mobile.css'

import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { installDeploymentRecovery } from './deploymentRecovery'
import { installAppComponents } from './plugins/appComponents'
import { vuetify } from './plugins/vuetify'
import PortalApp from './portal/PortalApp.vue'
import { initializePortalPwa } from './portal/pwa'
import { portalRouter } from './portal/portalRouter'
import { queryClient } from './queryClient'
import { installPortalOffline } from './portal/portalOffline'
import { installPortalChatRealtime } from './portal/portalChatRealtime'
import { useAuthStore } from './stores/auth'
import { initializePortalPreview, isPortalPreviewActive } from './portal/portalPreview'

initializePortalPreview()
installDeploymentRecovery()
if (!isPortalPreviewActive()) initializePortalPwa()

const app = createApp(PortalApp)

installAppComponents(app)
const pinia = createPinia()
app.use(pinia)
if (!isPortalPreviewActive()) installPortalOffline(queryClient, () => {
  void useAuthStore(pinia).initialize().then(session => {
    if (session) void queryClient.invalidateQueries({ queryKey: ['portal'] })
  }).catch(() => { /* Keep the read-only snapshot until the user retries or the connection recovers. */ })
})
if (!isPortalPreviewActive()) installPortalChatRealtime(queryClient, useAuthStore(pinia))
app.use(VueQueryPlugin, { queryClient })
app.use(vuetify)
app.use(portalRouter)
app.mount('#portal-app')
